module.exports = __webpack_public_path__ + "static/media/4.5ec4b8c1.svg";